import { getAemContent } from 'api/aem-content';
import { setInitialState, setIsLoading, setSuccess } from './aem-content-slice';

export const getAemContentThunk = (pageId, requestConfig) => async (
  dispatch
) => {
  try {
    dispatch(setInitialState(pageId));
    dispatch(setIsLoading(pageId));
    const response = await getAemContent(pageId, requestConfig);
    dispatch(setSuccess(response));
    return Promise.resolve(response);
  } catch {
    return Promise.resolve(null);
  }
};
